var booking = {
    page: function(){
        if($('#countryID').val() != 0){
            location.href = '/booking/booking/stage/' + $('#countryID').val();
        }
    },
    list: function(params){
        var getParams = location.pathname+"?"+($.param(params));

        if(window.history && window.history.replaceState)
        {
            window.history.replaceState(null, null, getParams);

            $.get(getParams, params, function(resp){
                $('#booking-table').html(resp);
            });
        } else {
            location.href=getParams;
        }
    },
    stageSVG: function (svg, partnershipID) {
        $('.st6', svg.contentDocument).attr("fill", "#555555").removeClass("st6");
        var format_types = [];
        // $(format, svg.contentDocument).attr("fill", "#00A0DE");
        $("#p"+partnershipID+' .format_type').each(function () {
            // console.log($(this).attr("data-type"));
            // $("."+$(this).attr("data-type"), svg.contentDocument).attr("fill", "#00A0DE");
            // format_types[$(this).attr("data-type")] = $(this).attr("data-type");
            var format_type = $(this).attr("data-type");
            if($(svg.contentDocument).find('.'+format_type).length == 0){
                $(svg.contentDocument).find("."+format_type.slice(0,-1)).first().attr("fill", "#00A0DE");
            }else{
                $(svg.contentDocument).find('.'+format_type).attr("fill", "#00A0DE");
            }
        });

        $(svg.contentDocument).find('rect').each(function () {
            // console.log($(this).hasClasses(format_types));
            if($(this).hasClasses(format_types)){
                $(this).attr("fill", "#00A0DE");
            }
        });
    },

    copyWeek: function(copyYear, copyWeek)
    {
        var copyTd = $('td.copy-paste-td.copied'),
            pasteTd = $('td.copy-paste-td[data-week="' + copyWeek + '"]'),
            tds = $('td.copy-paste-td'),
            length = tds.length;

        $.post('/booking/booking/copyWeek', {copyYear: copyYear, copyWeek: copyWeek}, function()
        {
            for(var i=0; i<length; i++) {
                var td = $(tds[i]),
                    title = 'Paste week: CW' + pasteTd.data('week') + ' => CW' + td.data('week'),
                    aPaste = td.find('a.paste');

                aPaste.attr('title', title)
                    .tooltip('fixTitle');


                if(td.data('week') == copyTd.data('week')) {
                    td.removeClass('copied');
                    aPaste.css('display', 'inline');
                } else if(td.data('week') == pasteTd.data('week')) {
                    td.addClass('copied')
                    aPaste.css('display', 'none');
                } else {
                    aPaste.css('display', 'inline');
                }
            }
        });
    },
    pasteWeek: function(pasteWeek) {
        $.post('/booking/booking/validationPasteWeek/' + pasteWeek, {}, function(resp){
            if(resp && typeof(resp.success) != 'undefined') {
                if(resp.success == 0) {
                    popup(resp.html, resp.title).confirm(true, function(result) {
                        if (result) {
                            $.post('/booking/booking/pasteWeek/' + pasteWeek, {}, function(resp){
                                location.reload();
                            });
                        }
                    });
                } else {
                    location.reload();
                }
            }
        }, 'json');
    },
    modifyBooking: function() {
        var IDs = "",
            mediagroupID = parseInt($('#bookedEditBox').find('.themes-dropdown').find('#mediagroupID').val());

        if(mediagroupID > 0) {
            $('.bookedselected').each(function() {
                if(IDs != "")
                    IDs += ",";

                IDs += $(this).data('reservationweek');
            });

            if(IDs != '') {
                $.post('/booking/booking/modifyBooking', {IDs: IDs, mediagroupID: mediagroupID}, function() {
                    location.reload();
                });
            }
        }
    },

    modifyStageBooking: function() {
        var IDs = "",
            rows = "",
            years = "",
            weeks = "",
            partnerships = "",
            mediagroupID = parseInt($('#bookedEditBox').find('.themes-dropdown').find('#mediagroupID').val());

        if(mediagroupID > 0) {
            $('.bookedselected').each(function() {
                if(typeof $(this).data('reservationweek') != 'undefined') {
                    if (IDs != "")
                        IDs += ",";

                    IDs += $(this).data('reservationweek');
                }else{
                    if (weeks != "") {
                        weeks += ",";
                        years += ",";
                        partnerships += ",";
                        rows += ",";
                    }

                    weeks += $(this).data('week');
                    years += $(this).data('year');
                    partnerships += $(this).data('partnership');
                    rows += typeof $(this).data('row') != 'undefined'?$(this).data('row'):'';
                }
            });

            // if(IDs != '') {
                $.post('/booking/booking/modifyStageBooking', {IDs: IDs, mediagroupID: mediagroupID, weeks:weeks,years:years,partnerships:partnerships,rows:rows}, function() {
                    location.reload();
                });
            // }
        }
    },

    modifyMediaBooking: function() {
        var IDs = "",
            years = "",
            weeks = "",
            themes = "",
            rows = "",
            mediaID = parseInt($('#bookedEditBox').find('.themes-dropdown').find('#mediaID').val());

        if(mediaID > 0) {
            $('.bookedselected').each(function() {
                if(typeof $(this).data('reservationweek') != 'undefined') {
                    if(IDs != "")
                        IDs += ",";

                        IDs += $(this).data('reservationweek');
                }else{
                    if (weeks != "") {
                        weeks += ",";
                        years += ",";
                        themes += ",";
                        rows += ",";
                    }

                    weeks += $(this).data('week');
                    years += $(this).data('year');
                    themes += $(this).data('theme');
                    rows += typeof $(this).data('row') != 'undefined'?$(this).data('row'):'';
                }
            });

            // if(IDs != '') {
                $.post('/booking/booking/modifyMediaBooking', {IDs: IDs, mediaID: mediaID, weeks:weeks, years:years,themes:themes, rows:rows}, function() {
                    location.reload();
                });
            // }
        }
    },

    modifyThemeBooking: function() {
        var IDs = "",
            years = "",
            weeks = "",
            partnerships = "",
            themeID = parseInt($('#bookedEditBox').find('.themes-dropdown').find('#themeID').val());

        if(themeID > 0) {
            $('.bookedselected').each(function() {
                if(typeof $(this).data('reservationweek') != 'undefined') {
                    if (IDs != "")
                        IDs += ",";

                    IDs += $(this).data('reservationweek');
                }else{
                    if (weeks != "") {
                        weeks += ",";
                        years += ",";
                        partnerships += ",";
                    }

                    weeks += $(this).data('week');
                    years += $(this).data('year');
                    partnerships += $(this).data('partnership');
                }
            });

            // if(IDs != '') {
                $.post('/booking/booking/modifyThemeBooking', {IDs: IDs, themeID: themeID, weeks:weeks, years:years,partnerships:partnerships}, function() {
                    location.reload();
                });
            // }
        }
    },

    themeModifyPopup: function(mediagroupID) {
        var mediagroupID = mediagroupID || 0;

        $.post('/booking/booking/themeModifyPopup/' + mediagroupID, {}, function(resp){
            $('#bookedEditBox').html(resp);
            $('#bookedEditBox').show();
        });
    },

    stageModifyPopup: function(mediagroupID) {
        var mediagroupID = mediagroupID || 0;

        $.post('/booking/booking/stageModifyPopup/' + mediagroupID, {}, function(resp){
            $('#bookedEditBox').html(resp);
            $('#bookedEditBox').show();
        });
    },

    themeBookingModifyPopup: function(themeID) {
        var themeID = themeID || 0;

        $.post('/booking/booking/themeBookingModifyPopup/' + themeID, {}, function(resp){
            $('#bookedEditBox').html(resp);
            $('#bookedEditBox').show();
        });
    },

    mediaModifyPopup: function(mediaID) {
        var mediaID = mediaID || 0;

        $.post('/booking/booking/mediaModifyPopup/' + mediaID, {}, function(resp){
            $('#bookedEditBox').html(resp);
            $('#bookedEditBox').show();
        });
    },

    themeNewPopup: function() {
        $.post('/booking/booking/themeNewPopup', {}, function(resp){
            $('#bookingBox').html(resp);
            $('#bookingBox').show();
        });
    },
    
    changeCountry: function () {
        var path = location.pathname.split('/');
        location.href = '/' + path[1] + '/' + path[2] + '/' + path[3] + '/' + $("#countryID").val();
        $.post('/booking/booking/changeCountry/' + $("#countryID").val(), {});
    }

};